import { render, staticRenderFns } from "./searchClient.vue?vue&type=template&id=18416d6f&scoped=true&"
import script from "./searchClient.vue?vue&type=script&lang=js&"
export * from "./searchClient.vue?vue&type=script&lang=js&"
import style0 from "./searchClient.vue?vue&type=style&index=0&id=18416d6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18416d6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
